
<template lang="pug">
  b-modal(v-model="modalShow", ref='newsModal_readMore', hide-footer, hide-header, size="lg", no-close-on-esc, no-close-on-backdrop)
    .modal--container
      ModalClose(@click.native="HIDE_MODAL")

      .stocknews--title
        .heading--h2 {{ news.title }}

      .stocknews--info.pad_t--15
        .row
          .col-lg-6
            small.text__uppercase 
              | <em>{{ news.author }}</em> ({{ news.provider }})
          .col-lg-6.align__right.align__left-md.pad_t--5-md
            small.text__uppercase.text--color_grey 
              | Date published: {{ news.date }}, {{ news.time }}

      .pad_t--25
        .text-justify(v-html="news.content")
        
      .pad_t--10
        .row
          .col-lg-3
            a.button.button-secondary.button_standard(v-if="news.link", :href="news.link", target="_blank")
              | Read More

          .col-lg-9.align__right.align__left-md.pad_t--10-md
            template(v-for="(counter, index) in news.relatedCounters")
              CounterDropdown.stocknews--counter(:counterCode="counter.attributes.code", :counterName="counter.attributes.name")

</template>




<script>
  import CounterDropdown from '../components/CounterDropdown';
  import ModalClose from '../components/ModalClose';

  export default {
    name: 'NewsModal',
    mixins: [],
    components: {
      CounterDropdown,
      ModalClose
    },

    props: {
      modalShow: {
        default: false,
        type: Boolean
      },
      news: {
        default: function() { return { } },
        type: Object
      },
    },

    data() {
      return {
      }
    },

    computed: {

    },

    methods: {
      HIDE_MODAL() {
        this.$emit('close');
      }
    },

    created() {
    },

  }

</script>




<style lang="scss">
  .stocknews--counter {
    + .stocknews--counter {
      margin-left: 10px;
    }
  }
  .stocknews--title {
    padding-bottom: 15px;
    border-bottom: 1px solid $color-standard-border;

    @include MQ(XSM) {
      padding-right: 16px;
    }
  }
  
</style>
